import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Table } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";

import { LanguageAPI } from "@/api";
import { useExportHandler, useImportHandler } from "@/hooks";
import Query from "@/models/query";
import ErrorsFormatter from "@/ui/_common_/errors-formatter";
import Page from "@/ui/_common_/page";

function Languages() {
  const [getAllQuery] = useState(() => new Query(LanguageAPI.getAll));
  const [importQuery] = useState(() => new Query(LanguageAPI.import));
  const [exportQuery] = useState(() => new Query(LanguageAPI.export));

  const handleImportClick = useImportHandler({ getAllQuery, importQuery });

  const handleExportClick = useExportHandler({
    exportQuery,
    fileName: "languages.csv",
  });

  useEffect(() => {
    getAllQuery.submit();
  }, [getAllQuery]);

  return (
    <Page title={"Languages"}>
      <ErrorsFormatter queries={[exportQuery, importQuery]} />
      <Card size="small">
        <Row gutter={[12, 12]} wrap={true}>
          <Col>
            <Button
              icon={<DownloadOutlined />}
              loading={importQuery.isPending}
              onClick={handleImportClick}
            >
              {"Import"}
            </Button>
          </Col>
          <Col>
            <Button
              icon={<UploadOutlined />}
              loading={exportQuery.isPending}
              onClick={handleExportClick}
            >
              {"Export"}
            </Button>
          </Col>
        </Row>
      </Card>
      <Card size="small">
        <Table
          loading={getAllQuery.isPending}
          dataSource={getAllQuery.isFulfilled ? getAllQuery.data.data : []}
          pagination={false}
          size="small"
          rowKey="code"
        >
          <Table.Column title={"Code"} dataIndex="code" />
          <Table.Column title={"Name"} dataIndex="name" width="100%" />
        </Table>
      </Card>
    </Page>
  );
}

export default observer(Languages);
